/* eslint i18next/no-literal-string: 0 */
import React, { Suspense } from 'react'
import PaginationLoader from '../../ui/paginationLoader/PaginationLoader'
import MenuNewCenter from './MenuNewCenter'
import MenuNewRight from './MenuNewRight'
import './menuNew.sass'

interface Props {
    getCurrentMenu: () => React.ReactNode
}

const MenuNew: React.FC<Props> = ({ getCurrentMenu }) => {
    return (
        <div className="menuNew">
            <div className="menuNew__left">
                <Suspense fallback={<PaginationLoader />}>{getCurrentMenu()}</Suspense>
            </div>
            <div className="menuNew__center">
                <MenuNewCenter />
            </div>
            <div className="menuNew__right">
                <MenuNewRight />
            </div>
        </div>
    )
}

export default MenuNew
